<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { debounce } from "../../../helpers/helper";

//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      moment,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      status: status == undefined ? "1" : status,
      limit: 50,
      perPage: perPage || 50,
      search: "",
      activity: "",

      searchData: debounce(() => {
        const { perPage, status, orderBy, sortBy } = this.$data;
        this.$router.replace({
          name: "activity",
          query: { perPage, status, orderBy, sortBy },
        });
        let page = 1;
        this.getActivityList({
          page: page,
          perPage: this.perPage,
          search: this.search,
          status: this.status,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
        });
      }, 500),
    };
  },
  computed: mapGetters("activity", ["loading", "paginations", "activities", "admin"]),
  mounted() {
    let orderBy = this.sortDesc ? "desc" : "asc";
    let page = 1;
    this.getActivityList({
      page: page,
      perPage: this.perPage,
      search: this.search,
      status: this.status,
      sortBy: this.sortBy,
      orderBy: orderBy,
    });
  },
  methods: {
    ...mapActions("activity", ["getActivityList"]),
    showActivity(page = 1) {
      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getActivityList({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
      });

      // this.getActivityList(id).then((res) => {
      //   this.activity = res.data.activity;
      //   this.admin = res.data.admin;
      // });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <!-- <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx-category-alt"></i>
                            </span> -->
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">Activities({{ activities.total }})</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-6"></div>
              <div class="col-sm-2"></div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="activities.total > 0">
              <ul class="verti-timeline list-unstyled mt-4 ml-4">
                <div v-for="data in activities.data" :key="data.id">
                  <!-- <li class="event-list mb-5">
                        <div class="event-timeline-dot">
                          <i class="bx bx-right-arrow-circle font-size-18"></i>
                        </div>
                        <div class="media">
                          <div class="mr-3">
                            {{ data.subject }}
                            <i
                              class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                            ></i>
                          </div>

                          <div class="media-body">
                            <h5 class="font-size-14">
                              {{ moment(data.created_at).fromNow() }}
                            </h5>
                            <h5 class="font-size-14 tooltip">
                              <i class="bx bx-time"></i>
                              <span class="tooltiptext">{{
                                moment(data.created_at).format("MMM D YYYY, h:mm a")
                              }}</span>
                            </h5>
                          </div>
                        </div>
                      </li> -->
                  <li class="event-list mb-5">
                    <div class="event-timeline-dot">
                      <i class="bx bx-right-arrow-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="subject-data">
                        <div>
                          <h6>
                            Admin <b>{{ admin.name }}</b> {{ data.subject }}
                          </h6>
                        </div>
                        <div class="tooltip">
                          {{ moment(data.created_at).fromNow()
                          }}<i class="bx bx-time ml-1 text-primary"></i>
                          <span
                            class="tooltiptext"
                            style="bottom: 50% !important; margin-left: -86px !important"
                            >{{
                              moment(data.created_at).format("MMM D YYYY, h:mm a")
                            }}</span
                          >
                        </div>
                      </div>
                      <!-- <div class="ml-3">
                        <h5 class="font-size-14">
                          {{ moment(data.created_at).fromNow() }}
                        </h5>
                        <h5 class="font-size-14 tooltip2">
                          <i class="bx bx-time"></i>
                          <span class="tooltiptext2">{{
                            moment(data.created_at).format("MMM D YYYY, h:mm a")
                          }}</span>
                        </h5>
                      </div> -->
                    </div>
                  </li>
                </div>
              </ul>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="showActivity"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="justify-content-center row" v-else>
              <label class="align-middle mt-2">No activities yet</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
